import http from '../util/http.js'
export const ListAudit = (auditId,auditName,startDate,endDate,sort,sortType,page,pageSize = 10) => http.get('/audit/auditList',{auditId,auditName,startDate,endDate,sort,sortType,page,pageSize})

export const DownloadAudit = (id) => http.get('/audit/download',{id})